import { NgForm } from '@angular/forms';
import { Angulartics2 } from 'angulartics2';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { UserSettingsService } from 'app/user/user-settings.service';
import { WizardService } from 'app/orders/wizard/wizard.service';
import { WizardUploadComponent } from 'app/orders/wizard/upload/upload.component';
import { camelCase } from 'app/core/case-transform';
import { PersonalizedLocalStorageService } from 'app/notifications/personalized-local-storage.service';
import { ApplicationsService } from 'app/applications/applications.service';
var WizardCreateComponent = /** @class */ (function () {
    function WizardCreateComponent(_settings, _angulartics2, _dialogService, _userSettingsService, _wizardService, _applicationsService, _personalizedLocalStorageService) {
        this._settings = _settings;
        this._angulartics2 = _angulartics2;
        this._dialogService = _dialogService;
        this._userSettingsService = _userSettingsService;
        this._wizardService = _wizardService;
        this._applicationsService = _applicationsService;
        this._personalizedLocalStorageService = _personalizedLocalStorageService;
        this.isLoading = false;
        this.templateError = 'Error';
        this.templateErrorDescription = 'Error of processing of parameters';
    }
    Object.defineProperty(WizardCreateComponent.prototype, "visibleRegion", {
        get: function () {
            return (this._userSettingsService.serviceType === 'ic');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WizardCreateComponent.prototype, "isFilesReady", {
        get: function () {
            return this._settings.isFilesReady;
        },
        enumerable: true,
        configurable: true
    });
    WizardCreateComponent.prototype.ngOnInit = function () {
        this.orderSettingsDc = [];
        this.orderSettings = Object.assign({}, this._userSettingsService.orderSettings);
        this.rememberImportSettings = this._userSettingsService.rememberImportSettings;
    };
    WizardCreateComponent.prototype.back = function () {
        this._saveSettings();
        this._dialogService.open(WizardUploadComponent, { data: this._settings });
    };
    WizardCreateComponent.prototype.canStartProcess = function (form) {
        return !this.isLoading && form.valid && this.isFilesReady;
    };
    WizardCreateComponent.prototype.onSubmit = function (form) {
        var _this = this;
        if (form.valid && this._isValidOrderSettings()) {
            this.onHideError();
            this.isLoading = true;
            this._saveSettings();
            var data = {};
            try {
                if (this.isIc()) {
                    data.verification = this.orderSettings.verificationType;
                    data.export_format = this.orderSettings.exportFormat;
                    data.region = this.orderSettings.region;
                }
                else {
                    // [TFS-128713]: При загрузке файла в DC не передаются регистрационные параметры
                    if (this._applicationsService.defaultApplication().isCustomized) {
                        // Выставляем дефолтные значения только для демо-приложений
                        var _temp = this.orderSettingsDc.reduce(function (acc, cur) {
                            if (cur.name && cur.name !== '') {
                                acc[cur.name] = cur.value || '';
                            }
                            return acc;
                        }, {});
                        Object.assign(data, _temp);
                    }
                    else {
                        var _temp = this.orderSettingsDc.reduce(function (acc, cur) {
                            if (cur.name && cur.name !== '') {
                                acc[cur.name] = cur.value || '';
                            }
                            return acc;
                        }, {
                            document_type: this._userSettingsService.documentType,
                            verification: this.orderSettings.verificationType,
                            export_format: this.orderSettings.exportFormat,
                            region: this.orderSettings.region,
                        });
                        Object.assign(data, this.orderSettings);
                        Object.assign(data, _temp);
                    }
                }
                this._wizardService.create(data, this._userSettingsService.serviceType).subscribe(function (order) {
                    _this._personalizedLocalStorageService.setJson('order_properties', _this.orderSettingsDc);
                    var properties = {
                        event: 'Create Order',
                        'Service Type': order.serviceType,
                        'Document Count': _this._wizardService.files.length,
                        'Export Format': _this.orderSettings.exportFormat,
                        'Invoice Region': _this.orderSettings.region,
                        'Verification Type': _this.orderSettings.verificationType,
                        'Number': order.number
                    };
                    if (!_this.isIc()) {
                        delete properties['Invoice Region'];
                    }
                    _this._angulartics2.eventTrack.next({
                        action: 'Create Order',
                        properties: properties
                    });
                    _this._wizardService.reset();
                    _this._dialogService.close();
                }, function (error) { return _this._onError(error); });
            }
            catch (error) {
                data = {};
                this.error = this.templateError;
                this.errorDescription = this.templateErrorDescription;
                console.error(error);
                this.isLoading = false;
            }
        }
    };
    WizardCreateComponent.prototype.isIc = function () {
        return (this._userSettingsService.serviceType === 'ic');
    };
    WizardCreateComponent.prototype.onHideError = function () {
        this.error = null;
        this.errorDescription = null;
    };
    WizardCreateComponent.prototype._onError = function (response) {
        if (response.status === 400) {
            var responseJson = response.json();
            this.error = camelCase(responseJson.error);
            this.errorDescription = this._getErrorDescription(responseJson);
        }
        else {
            this.error = this.templateError;
            this.errorDescription = this.templateErrorDescription;
        }
        this.isLoading = false;
    };
    WizardCreateComponent.prototype._saveSettings = function () {
        this._userSettingsService.orderSettings = Object.assign({}, this.orderSettings);
        this._userSettingsService.rememberImportSettings = this.rememberImportSettings;
    };
    WizardCreateComponent.prototype._getErrorDescription = function (responseJson) {
        var modelState = responseJson.modelState;
        if (!modelState) {
            return responseJson.errorDescription;
        }
        return Object.keys(modelState)
            .map(function (fieldName) { return modelState[fieldName].join('\n'); })
            .join('\n');
    };
    WizardCreateComponent.prototype._isValidOrderSettings = function () {
        var isNoError = true;
        if (!this.isIc()) {
            this.orderSettingsDc.forEach(function (value, i, array) {
                if (value.name === '' && value.value !== '') {
                    array[i].errorValue = true;
                    isNoError = false;
                }
                else {
                    array[i].errorValue = false;
                }
            });
        }
        return isNoError;
    };
    WizardCreateComponent.prototype.setOrderSettingsDc = function (value) {
        this.orderSettingsDc = value;
    };
    WizardCreateComponent.prototype.onKeydownHandler = function (event) {
        if (event.keyCode === 13 && this.canStartProcess(this.form)) {
            this.onSubmit(this.form);
        }
    };
    return WizardCreateComponent;
}());
export { WizardCreateComponent };
